export default __webpack_public_path__ + "static/heroSectionImage-7a21733701a1163f9e50204f1879e8ec.png";